__turbopack_context__.v({
  "card-edit-input-container": "NameEditPopover-module-scss-module__hom8iq__card-edit-input-container",
  "link-chip-container": "NameEditPopover-module-scss-module__hom8iq__link-chip-container",
  "name-edit-popover": "NameEditPopover-module-scss-module__hom8iq__name-edit-popover",
  "show-all-btn-container": "NameEditPopover-module-scss-module__hom8iq__show-all-btn-container",
});
